import React from 'react';
import { Checkbox, FormControlLabel, MenuItem, TextField } from "@mui/material";
import { useField, useFormikContext } from "formik";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { DatePicker } from "@mui/x-date-pickers";

function CustomSelectField({ name, label, required, options, ...props }) {
    const { handleBlur, setFieldValue, errors, touched, values } =
        useFormikContext();

    return (
        <TextField
            select
            required={required}
            name={name}
            label={label || name}
            helperText={touched?.[name] && errors?.[name]}
            error={touched?.[name] && Boolean(errors?.[name])}
            onBlur={handleBlur}
            onChange={(e) => setFieldValue(name, e.target.value)}
            value={values?.[name]}
            {...props}>
            {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
    );
}

function getNestedProperty(obj, path) {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
}


function CustomTextField({ name, label, required, ...props }) {
    const { handleBlur, setFieldValue, errors, touched, values } =
        useFormikContext();
    const [field] = useField(name)

    return (
        <TextField
            required={required}
            name={name}
            label={label || name}
            helperText={touched?.[name] && errors?.[name]}
            error={touched?.[name] && Boolean(errors?.[name])}
            onBlur={handleBlur}
            onChange={(e) => setFieldValue(name, e.target.value)}
            value={getNestedProperty(values, name)}
            InputLabelProps={{
                shrink: !!field.value,
            }}

            {...props}
        />
    );
}

const CustomCheckboxField = ({ name, label, ...props }) => {
    const [field, _, helpers] = useField(name);
    return (
        <FormControlLabel
            control={
                <Checkbox
                    name={String(name)}
                    checked={Boolean(field.value)}
                    onChange={(_, value) => helpers.setValue(value)}
                    {...props}
                />
            }
            label={label || String(name)}
        />
    );
};



const CustomDateField = ({ name, label, required, ...props }) => {
    const { setFieldValue, errors, touched } = useFormikContext();
    const [field, meta, helpers] = useField(name);

    dayjs.extend(utc);
    dayjs.extend(timezone);

    // Type guard to check if value is Day.js-compatible
    const parseDateValue = (value) => {
        if (!value) return null; // Handle null/undefined
        if (typeof value === 'string' || value instanceof Date) {
            return dayjs(value);
        }
        return null; // Fallback for incompatible types
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                disableFuture
                label={label}
                name={name}
                timezone="utc"
                value={parseDateValue(field.value)}
                onChange={(date) => {
                    const utcDate = dayjs.utc(date); // Ensure date is UTC
                    setFieldValue(name, utcDate.format('YYYY-MM-DD'));
                    // setFieldValue(name, date);
                }}
                slotProps={{
                    textField: {
                        helperText:
                            (touched?.[name] &&
                                errors?.[name]) ? String(errors?.[name]) : "mm/dd/yyyy",
                        error: touched?.[name] && Boolean(errors?.[name]),
                        required: required
                    }
                }}
                {...props}
            />
        </LocalizationProvider>
    )

}

export { CustomSelectField, CustomDateField, CustomCheckboxField };
export default CustomTextField;
